// import React from 'react'


// const ScromPlayerFun = () => {
//     const AllCourse = [
//         { id: 1, name: "course1" },
//         { id: 2, name: "course2" },
//         { id: 3, name: "course3" },
//         { id: 4, name: "course4" },
//         { id: 5, name: "course5" },
//         { id: 6, name: "course6" },
//         { id: 7, name: "course7" },
//         { id: 8, name: "course8" }
//       ]

//   return (
//     <div>
//         {AllCourse.map((course, index)=>(
//             <button key={course?.id}>{course?.name}</button>
//         ))}
//         <div>
            
//         </div>
//        <div style={{ width: '100%', height: '100vh' }}>
//         <iframe
//           src={`course3/index.html`}
//           title="YouTube video player"
//             height="100%"
//             width="100%"
//         ></iframe>
//       </div>
//     </div>
//   )
// }

// export default ScromPlayerFun

import React, { useState } from 'react';

const ScromPlayerFun = () => {
  const AllCourse = [
    { id: 1, name: "course1" },
    { id: 2, name: "course2" },
    { id: 3, name: "course3" },
    { id: 4, name: "course4" },
    { id: 5, name: "course5" },
    { id: 6, name: "course6" },
    { id: 7, name: "course7" },
    { id: 8, name: "course8" }
  ];

  const [currentCourse, setCurrentCourse] = useState(AllCourse[0]);

  return (
    <div>
      <div style={{ marginBottom: 20 }}>
        {AllCourse.map((course) => (
          <button
            key={course.id}
            onClick={() => setCurrentCourse(course)}
            style={{
              margin: '5px',
              padding: '8px 16px',
              backgroundColor: currentCourse.id === course.id ? '#1890ff' : '#f0f0f0',
              color: currentCourse.id === course.id ? '#fff' : '#000',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            {course.name}
          </button>
        ))}
      </div>

      <div>
        <h3>Current Course: {currentCourse.name}</h3>
      </div>

      <div style={{ width: '100%', height: '100vh' }}>
        <iframe
          src={`${currentCourse.name}/index.html`}
          title={currentCourse.name}
          height="100%"
          width="100%"
        ></iframe>
      </div>
    </div>
  );
};

export default ScromPlayerFun;
